import React, { ComponentType, FC } from "react";
import withLoader, { WithLoaderConfig } from "./withLoader";

export type WithLoaderHOCProps = {
  isLoading?: boolean;
  loaderConfig?: WithLoaderConfig;
};

// eslint-disable-next-line @typescript-eslint/ban-types
const withLoaderHOC = <P extends object>(
  WrappedComponent: ComponentType<P>,
  config?: WithLoaderConfig
) => {
  const CompositeComponent: FC<P & WithLoaderHOCProps> = (props) => {
    const { isLoading = false, loaderConfig, ...rest } = props;
    const combinedConfig = { ...config, ...loaderConfig };

    return withLoader(
      <WrappedComponent {...(rest as P)} />,
      isLoading,
      combinedConfig
    );
  };

  CompositeComponent.displayName = `withLoader(${WrappedComponent.displayName})`;

  return CompositeComponent;
};

export type WithLoaderHOC<WrappedComponentProps> = WrappedComponentProps &
  WithLoaderHOCProps;

export default withLoaderHOC;
